import type * as React from 'react';

import { cn } from '@/lib/utils';

/* ============================================================
   입력칸 — 우리 자와 포커스 규칙에 맞췄다
   ------------------------------------------------------------
   받아온 판에서 고친 것 넷.

   1. **`outline-none` + `ring` 포커스** — 이 앱은 `:focus-visible` 에 2px
      외곽선을 전역으로 건다. `outline-none` 이 그것을 죽이면 **옮긴 화면과
      안 옮긴 화면의 포커스 모양이 달라진다.** ring 을 걷고 전역 외곽선에 맡긴다.
   2. **`text-base md:text-sm`** — 화면 폭에 따라 글자 크기가 바뀐다. 우리
      자는 폭과 무관하다. `text-meta`(13px) 하나로 고정했다.
   3. **`border-input` 뿐** — 색 이름이 없으면 preflight 를 안 들이는 이 앱에서
      테두리가 `currentColor`(잉크색)로 새까매진다. `border-line-2` 를 못박았다.
   4. **높이 `h-9`·`px-3`** — 우리 자로 갈아 끼웠다.
   ============================================================ */

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'h-8 w-full min-w-0 rounded-md border border-line-2 bg-panel px-s3 text-meta text-ink',
        // 좁은 화면: 손가락 44px · 16px 글자(iOS 가 그 아래에서 초점 확대를 한다)
        'max-[720px]:h-[44px] max-[720px]:text-lead',
        'transition-colors placeholder:text-ink-3',
        'selection:bg-brand selection:text-on-brand',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-invalid:border-st-red-f',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
